import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@mui/material";

import useBenchmarkSummaryQuery from "../../useQuery/useBenchmarkSummaryQuery";

const SummaryReport = ({ tsrId }) => {

  const { data, isSuccess, isLoading } = useBenchmarkSummaryQuery(tsrId);

  let devices = [];

  if (data && data.length > 0) {

    const deviceSet = new Set();

    data.forEach(row => {
      Object.keys(row).forEach(key => {
        if (key.endsWith("_avg")) {
          deviceSet.add(key.replace("_avg", ""));
        }
      });
    });

    devices = Array.from(deviceSet);

  }

  return (

    <Box pt={2}>

      {isLoading && <div>Loading...</div>}

      {isSuccess && data?.length > 0 && (

        <Table>

          <TableHead>

            <TableRow>

              <TableCell><b>Milestone</b></TableCell>
              <TableCell><b>Metric</b></TableCell>

              {devices.map(device => (
                <TableCell key={device} align="center">
                  <b>{device}</b>
                </TableCell>
              ))}

              <TableCell><b>Commentary</b></TableCell>

            </TableRow>

          </TableHead>

          <TableBody>

            {data.map(row => (

              <>
                <TableRow key={`${row.milestone}-avg`}>

                  <TableCell rowSpan={2}>
                    {row.milestone}
                  </TableCell>

                  <TableCell>
                    Avg Time
                  </TableCell>

                  {devices.map(device => {

                    const avg = row[`${device}_avg`];

                    return (
                      <TableCell key={`${row.milestone}-${device}-avg`} align="center">
                        {avg ? `${avg.toFixed(2)} s` : "-"}
                      </TableCell>
                    );

                  })}

                  <TableCell>
                    {row.speed_comment || "-"}
                  </TableCell>

                </TableRow>

                <TableRow key={`${row.milestone}-fail`}>

                  <TableCell>
                    Failure %
                  </TableCell>

                  {devices.map(device => {

                    const fail = row[`${device}_failureRate`];

                    return (
                      <TableCell key={`${row.milestone}-${device}-fail`} align="center">
                        {fail !== undefined ? `${(fail * 100).toFixed(1)}%` : "-"}
                      </TableCell>
                    );

                  })}

                  <TableCell>
                    {row.most_reliable_device
                      ? `${row.most_reliable_device} more reliable`
                      : "-"}
                  </TableCell>

                </TableRow>

              </>

            ))}

          </TableBody>

        </Table>

      )}

    </Box>

  );

};

export default SummaryReport;